export const VALIDATION_RULES = {
  username: {
    min: 3,
    max: 30,
    pattern: '^[a-zA-Z0-9_]+$',
  },
  password: {
    min: 12,
    pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]+$',
  },
  channel_name: {
    min: 2,
    max: 50,
    pattern: '^[a-z0-9-]+$',
  },
};
